import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { Alert, AlertTitle } from '@mui/lab';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from "@mui/material/Typography";
import {connect} from 'react-redux'
import moment from 'moment'
import 'moment-timezone'
import {Collapse} from '@mui/material';

import FromToLocationPicker from '../../@opentripplanner/from-to-location-picker/src'

import Icon from '../narrative/icon'
import {calcRemainingHeight, setMainPanelContent, toggleAutoRefresh,setViewedRoute} from '../../actions/ui'
import {findStop, findStopTimesForStop, findRoutesAndTimesForStop, findStopAlerts,findPatternsForRoute} from '../../actions/api'
import { setActiveItinerary } from '../../actions/narrative'
import {forgetStop, rememberStop, setLocation} from '../../actions/map'
//import { routeComparator } from '../../@opentripplanner/core-utils/src/itinerary'
import {getShowUserSettings, getStopViewerConfig} from '../../@opentripplanner/core-utils/src/state'
import {formatDuration, getTimeFormat, getUserTimezone} from '../../@opentripplanner/core-utils/src/time'
import i18n from "../../../i18nSetup";
import {getFormattedStopTime} from './stop-time';
import {rewriteHeadsign} from '../../actions/ui'
import SchedulesButton from "./schedules-button";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import {InfoOutlined} from "@mui/icons-material";
import {ReactComponent as ArrowBackIcon} from '../../assets/arrowBack.svg';
import {ReactComponent as RefreshIcon} from '../../assets/refresh.svg';
import {ReactComponent as FavoriteIcon} from '../../assets/favorite.svg';
import {ReactComponent as FavoriteFilled} from '../../assets/favoriteFilled.svg';
import {ReactComponent as DotIcon} from '../../assets/dot.svg';
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import FormControlLabel from "@mui/material/FormControlLabel";
import Container from "@mui/material/Container";
import {TypographySubTitle} from "../../styles/components/customTypography";
import Link from "@mui/material/Link";


class StopViewer extends Component {
  state = {alertsExpanded: new Set()}

  static propTypes = {
    hideBackButton: PropTypes.bool,
    stopData: PropTypes.object,
    viewedStop: PropTypes.object
  }

  _backClicked = () => this.props.setMainPanelContent(null)

  _setLocationFromStop = (locationType) => {
    const { setLocation, stopData } = this.props
    const location = {
      name: stopData.name,
      lat: stopData.lat,
      lon: stopData.lon
    }
    setLocation({ locationType, location, reverseGeocode: true })
    this.setState({ popupPosition: null })
  }

  _onClickPlanTo = () => this._setLocationFromStop('to')

  _onClickPlanFrom = () => this._setLocationFromStop('from')

  _refreshStopTimes = () => {
    const { findStopTimesForStop, viewedStop,agencyFilter } = this.props
    findStopTimesForStop({ stopId: viewedStop.stopId,agencyFilter })
    // TODO: GraphQL approach would just call findStop again.
    // findStop({ stopId: viewedStop.stopId })
    this.setState({ spin: true })
    window.setTimeout(this._stopSpin, 1000)
  }

  _onToggleAutoRefresh = () => {
    const { autoRefreshStopTimes, toggleAutoRefresh } = this.props
    if (autoRefreshStopTimes) {
      toggleAutoRefresh(false)
    } else {
      // Turn on auto-refresh and refresh immediately to give user feedback.
      this._refreshStopTimes()
      toggleAutoRefresh(true)
    }
  }

  _stopSpin = () => this.setState({ spin: false })

  componentDidMount () {
    // Load the viewed stop in the store when the Stop Viewer first mounts
    let params = { stopId: this.props.viewedStop.stopId,agencyFilter:this.props.agencyFilter };
    if(!this.props.stopData || !this.props.stopData.name){
        this.props.findStop(params)
    }else if(!this.props.stopData.routes){
    
      this.props.findRoutesAndTimesForStop(params)
    }else{
      this._refreshStopTimes();
    }
    this.props.findStopAlerts(params);
    //}else{

    //}
    // Turn on stop times refresh if enabled.
    if (this.props.autoRefreshStopTimes) this._startAutoRefresh()
  }

  componentWillUnmount () {
    // Turn off auto refresh unconditionally (just in case).
    this._stopAutoRefresh()
  }

  _startAutoRefresh = () => {
    const timer = window.setInterval(this._refreshStopTimes, 30000)
    this.setState({ timer })
  }

  _stopAutoRefresh = () => {
    window.clearInterval(this.state.timer)
  }

  _toggleFavorite = () => {
    const { forgetStop, rememberStop, stopData } = this.props
    if (this._isFavorite()) forgetStop(stopData.id)
    else rememberStop(stopData)
  }

  _isFavorite = () => this.props.stopData &&
    this.props.favoriteStops.findIndex(s => s.id === this.props.stopData.id) !== -1

  // refresh the stop in the store if the viewed stop changes w/ the
  // Stop Viewer already mounted
  componentDidUpdate (prevProps) {
    if (
      prevProps.viewedStop &&
      this.props.viewedStop &&
      prevProps.viewedStop.stopId !== this.props.viewedStop.stopId
    ) {
      this.props.findStop({ stopId: this.props.viewedStop.stopId })
    }
    // Handle stopping or starting the auto refresh timer.
    if (prevProps.autoRefreshStopTimes && !this.props.autoRefreshStopTimes) this._stopAutoRefresh()
    else if (!prevProps.autoRefreshStopTimes && this.props.autoRefreshStopTimes) this._startAutoRefresh()
  }

  render () {
    const {
      hideBackButton,
      homeTimezone,
      showUserSettings,
      stopData,
      stopViewerArriving,
      stopViewerConfig,
      timeFormat,
      dir,
      alerts,
      setViewedRoute,
      findPatternsForRoute,
      setActiveItinerary
    } = this.props
    const {spin} = this.state
    // Rewrite stop ID to not include Agency prefix, if present
    // TODO: make this functionality configurable?
    let stopId
    if (stopData && stopData.code) {
      stopId = stopData.code
    }
    // construct a lookup table mapping pattern (e.g. 'ROUTE_ID-HEADSIGN') to an array of stoptimes
    const stopTimesByPattern = {};
    let stopTimesArr = [];
    if (stopData && stopData.routes && stopData.stopTimes) {
      stopData.stopTimes.forEach(patternTimes => {
        const routeId = getRouteIdForPattern(patternTimes.pattern)
        const headsign = patternTimes.times[0] && patternTimes.times[0].headsign
        patternTimes.pattern.headsign = headsign
        const id = `${routeId}-${headsign}`
        if (!(id in stopTimesByPattern)) {
          const route = stopData.routes.find(r => r.id === routeId)
          // in some cases, the TriMet transit index will not return all routes
          // that serve a stop. Perhaps it doesn't return some routes if the
          // route only performs a drop-off at the stop... not quite sure. So a
          // check is needed to make sure we don't add data for routes not found
          // from the routes query.
          if (!route) {
            console.warn(`Route with id ${routeId} not found in list of routes! No stop times from this route will be displayed.`)
            return
          }
          stopTimesByPattern[id] = {
            id,
            route,
            pattern: patternTimes.pattern,
            times: []
          }
        }
        const filteredTimes = patternTimes.times.filter(stopTime => {
          return stopTime.stopIndex < stopTime.stopCount - 1 // ensure that this isn't the last stop
        });
        stopTimesByPattern[id].times = stopTimesByPattern[id].times.concat(filteredTimes)
      });

      Object.values(stopTimesByPattern).forEach((stopTimesPattern, index) => {
        let stopTimesLimit = stopTimesPattern.times
          .concat()
          .sort((a, b) => {
            const aTime = a.serviceDay + a.realtimeDeparture;
            const bTime = b.serviceDay + b.realtimeDeparture;
            return aTime - bTime
          }).slice(0, stopViewerConfig.numberOfDepartures);

        stopTimesLimit?.forEach((time) => {
          stopTimesArr.push({
            route: stopTimesPattern.route,
            pattern: stopTimesPattern.pattern,
            time
          })
        });
      });
    }
    return (
      <>
        <Box>
          <Stack spacing={2} direction={'column'} alignItems="flex-start">
            <Box sx={{width: '100%'}}>
              <Box pr={2} pl={2}>
                <Stack spacing={2} direction={'column'} alignItems="flex-start">
                  <Divider flexItem/>
                  {!hideBackButton &&
                  <Button startIcon={<ArrowBackIcon style={{transform: (dir === 'rtl') ? 'scaleX(-1)' : 'none'}}/>}
                          style={{
                            color: '#4B33A5',
                            justifyContent: "flex-start",
                            paddingRight: 2,
                            paddingLeft: 2
                          }} variant="plain"
                          onClick={this._backClicked}>{i18n.t('back')}</Button>}
                </Stack>
              </Box>
            </Box>
            {stopData
              ? (
                <>
                  <Box sx={{width: '100%'}}>
                    <Grid sx={{paddingLeft: 2, paddingRight: 2}} style={{marginTop: 0}} container
                          justifyContent="space-between" alignItems="center">
                      <Grid item xl={9} md={10} xs={10}>
                        <Stack spacing={2} direction={'column'} alignItems="flex-start">
                          <Stack spacing={0} direction={'row'} alignItems="center">
                            <Typography sx={{fontSize: 22, fontWeight: 600}}>
                              {stopData.name}
                            </Typography>
                            {
                              showUserSettings
                                ?
                                <IconButton
                                            onClick={this._toggleFavorite}>
                                  {this._isFavorite() ? ( <FavoriteIcon />) : ( <FavoriteFilled />)}
                                </IconButton>
                                : null
                            }
                          </Stack>
                          <Box>
                            {stopId ? (<Typography>
                              {i18n.t('stopId')}: {stopId}
                            </Typography>) : null}
                            {stopData.formatted_address ? (<Typography>
                              {i18n.t('address')}: {stopData.formatted_address}
                            </Typography>) : null}
                          </Box>
                          <Box>
                            <Typography sx={{fontSize: 14}}>
                              {i18n.t('PlanTrip') + ": "}
                            </Typography>
                            <FromToLocationPicker onFromClick={this._onClickPlanFrom} onToClick={this._onClickPlanTo}/>
                          </Box>
                        </Stack>
                      </Grid>
                      <Grid item xl={3} md={2} xs={2}>
                        <Stack direction="row" gap={1} alignItems="center" justifyContent="flex-end">
                          <IconButton onClick={this._refreshStopTimes}>
                            <RefreshIcon
                              className={spin ? 'fa-spin' : ''}
                              type='refresh'/>
                          </IconButton>
                          <Typography variant="caption" color={'#4B33A5'}>
                            {moment(stopData.stopTimesLastUpdated)
                              .tz(getUserTimezone())
                              .format(timeFormat)}
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                    <Box>{alerts?.map((routeAlert, i) => (
                      <Alert key={"alert_" + i} style={{fontSize: 14, marginTop: 8, marginBottom: 0}}
                             severity="warning">
                        <AlertTitle full sx={{fontSize: 14, marginTop: 0, marginBottom: 0}} onClick={() => {
                          let alertsExpanded = this.state.alertsExpanded;
                          if (alertsExpanded.has(routeAlert.entityId)) {
                            alertsExpanded.delete(routeAlert.entityId)
                          } else {
                            alertsExpanded.add(routeAlert.entityId)
                          }

                          this.setState({alertsExpanded})
                        }
                        }>{routeAlert.alert.alertHeaderText}</AlertTitle>
                        {this.state.alertsExpanded.has(routeAlert.entityId) ? routeAlert.alert.alertDescriptionText : null}
                      </Alert>))}</Box>
                  </Box>
                  <Box id={'stop-times-list'} sx={{width: '100%'}}>
                    {stopData.stopTimes && stopData.routes && (
                      <>
                        <List sx={{width: '100%', overflow: 'auto', maxHeight: calcRemainingHeight('stop-times-list')}}>
                          {stopTimesArr
                            .sort((a, b) => {
                              if (!a.time) {
                                return 1;
                              }
                              if (!b.time) {
                                return -1;
                              }

                              const aTime = a.time.serviceDay + a.time.realtimeDeparture;
                              const bTime = b.time.serviceDay + b.time.realtimeDeparture;
                              return aTime - bTime
                            })
                            .map((patternTimes, index) => {
                              if (!patternTimes.route) {
                                console.warn(`Cannot render stop times for missing route ID: ${getRouteIdForPattern(patternTimes.pattern)}`)
                                return null
                              }
                              return (
                                <PatternRow
                                  key={'patternRow_' + index}
                                  pattern={patternTimes.pattern}
                                  route={patternTimes.route}
                                  stopTime={patternTimes.time}
                                  stopViewerConfig={stopViewerConfig}
                                  index={index}
                                  stopViewerArriving={stopViewerArriving}
                                  homeTimezone={homeTimezone}
                                  timeFormat={timeFormat}
                                  stopData={stopData}
                                  setViewedRoute={setViewedRoute}
                                  setActiveItinerary={setActiveItinerary}
                                  findPatternsForRoute={findPatternsForRoute}
                                />
                              )
                            })
                          }
                        </List>
                      </>
                    )}
                  </Box>
                </>
              )
              : (<CircularProgress sx={{
                height: 24,
                width: 24,
                marginLeft: 8,
                marginRight: 8,
                alignItems: 'center',
                alignSelf: 'center'
              }}/>)
            }

          </Stack>
        </Box>
      </>
    )
  }
}

class PatternRow extends Component {
  constructor () {
    super()
    this.state = { expanded: false }
  }

  _toggleExpandedView = () => {
    this.setState({ expanded: !this.state.expanded })
  }

  _onClick = (e) => {
    e && e.preventDefault();
    const { setViewedRoute,pattern,findPatternsForRoute,setActiveItinerary} = this.props
      // Otherwise, set active and fetch route patterns.
      let route = this.props.route;
      if(route && route.route){
          route = route.route; // match busnearby response
  
      }
     // setViewedTrip(null)
      setActiveItinerary(null)
     // findRoute({ routeId: route.id,pattern }, locale, agencyFilter)  // have redundant step
     findPatternsForRoute({ routeId: route.id,patternId:pattern.id }) 
      
      setViewedRoute({ routeId: route.id,pattern:pattern.id,route,headsign:pattern.headsign })
  
  }

  render () {
    const {
      pattern,
      route,
      stopTime,
      homeTimezone,
      index,
      stopViewerArriving,
      stopViewerConfig,
      timeFormat,
      stopData
    } = this.props;
    const routeName = route.shortName ? route.shortName : route.longName;
    const routeId = getRouteIdForPattern(pattern);
    return (
      <>
        {index == 0 && <Divider flexItem/>}
        <ListItem alignItems="center">
          <Grid container alignItems="center" justifyContent="space-between" sx={{width: '100%'}}>
            <Grid item md={8}>
              <Box>
                <Stack direction="row" gap={1} alignItems="center" justifyContent="flex-end">
                  <Box mx="auto" fontWeight="fontWeightBold" p={0.25} pr={1} pl={1} sx={{
                    alignContent: 'center',
                    textAlign: 'center',
                    backgroundColor: '#' + (route.color || '000'),
                    color: '#' + (route.textColor || 'FFFFFF'),
                    borderRadius: '3px',
                  }}>
                    {routeName}
                  </Box>
                  <ListItemText>
                    <Link onClick={this._onClick} href={`/route/${pattern.id}`} underline="hover" color={'#000'} sx={{fontWeight: 400}}>
                      {`${i18n.t('toDirect')} ${rewriteHeadsign(pattern.headsign)}`}
                    </Link>
                  </ListItemText>
                </Stack>
              </Box>
            </Grid>
            <Grid item md={4}>
              <Stack direction="row" spacing={0} alignItems="flex-end" justifyContent="flex-end">
                <Stack direction="column" spacing={0} alignItems="flex-end" justifyContent="flex-end">
                  {stopTime && (
                    <>
                      <Typography variant="caption" className='next-trip-preview'>
                        {getFormattedStopTime(stopTime, homeTimezone, stopViewerArriving, timeFormat)}
                      </Typography>
                      <Stack direction="row" gap={1} alignItems="center" justifyContent="flex-end">
                        {stopTime.realtimeState === 'UPDATED'
                          ? getStatusLabel(stopTime.departureDelay)
                          : <TypographySubTitle>
                            {i18n.t('scheduled')}
                          </TypographySubTitle>
                        }
                        {stopTime.platform && <>
                          <DotIcon/>
                          <TypographySubTitle>{`${i18n.t('platform')} ${stopTime.platform}`}</TypographySubTitle>
                        </>
                        }
                      </Stack>
                    </>
                  )}
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </ListItem>
        <Divider flexItem/>
      </>
    )
  }
}

function getRouteIdForPattern (pattern) {
  if(pattern.route?.id){
    return pattern.route.id;
  }
  const patternIdParts = pattern.id.split(':')
  const routeId = patternIdParts[0] + ':' + patternIdParts[1]
  return routeId
}

// helper method to generate status label
function getStatusLabel (delay) {
  // late departure
  if (delay > 60) {
    return (
      <TypographySubTitle color={'#F42434'}>
        {i18n.t('late')}
      </TypographySubTitle>
    )
  }

  // early departure
  if (delay < -60) {
    return (
      <TypographySubTitle>
        {i18n.t('early')}
      </TypographySubTitle>
    )
  }

  return (
    <TypographySubTitle>
      {i18n.t('onTime')}
    </TypographySubTitle>
  )
}

// connect to redux store

const mapStateToProps = (state, ownProps) => {
  const showUserSettings = getShowUserSettings(state.otp)
  const stopViewerConfig = getStopViewerConfig(state.otp)
  const viewedStop =  state.otp.ui.viewedStop;
  const alerts =  viewedStop && state.otp.transitIndex.stopAlerts[viewedStop.stopId];
  return {
    autoRefreshStopTimes: state.otp.user.autoRefreshStopTimes,
    favoriteStops: state.otp.user.favoriteStops,
    homeTimezone: state.otp.config.homeTimezone,
    viewedStop,
    alerts,
    showUserSettings,
    stopData: state.otp.transitIndex.stops[state.otp.ui.viewedStop.stopId],
    stopViewerArriving: state.otp.config.language.stopViewerArriving,
    stopViewerConfig,
    dir:state.otp.config.dir,
    timeFormat: getTimeFormat(state.otp.config),
    agencyFilter:state.otp.currentQuery.agencyFilter
  }
}

const mapDispatchToProps = {
  findStopAlerts,
  findStop,
  findStopTimesForStop,
  findRoutesAndTimesForStop,
  forgetStop,
  rememberStop,
  setLocation,
  setMainPanelContent,
  toggleAutoRefresh,
  setViewedRoute,
  setActiveItinerary,
  findPatternsForRoute
}

export default connect(mapStateToProps, mapDispatchToProps)(StopViewer)
